export default "__VITE_ASSET__CC_Zxrrt__"